var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tw-w-full tw-h-full tw-bg-grey-100/60 tw-absolute tw-z-[1001]"})])}]

export { render, staticRenderFns }